export default __webpack_public_path__ + "static/media/hipercard.a35d24b5.svg";